<div class="header">
  <i class="fa fa-calendar-alt"></i>
  <br />
  Chọn khoảng thời gian bạn muốn xem.
</div>

<button class="input spacy" *ngIf="!selecting.from" (click)="selecting.from = !selecting.from">{{value == null ? 'Chọn ngày bắt đầu' : value.from | date : 'dd/MM/yyyy'}}</button>
<calendar *ngIf="selecting.from" [selected]="value ? value.from : null" (change)="select('from',$event)"></calendar>
<button class="input spacy" *ngIf="!selecting.to" (click)="selecting.to = !selecting.to">{{value == null ? 'Chọn ngày kết thúc' : value.to | date : 'dd/MM/yyyy'}}</button>
<calendar *ngIf="selecting.to" [selected]="value ? value.to : null" (change)="select('to',$event)"></calendar>
<button *ngIf="!selecting.from && !selecting.to && value" class="submit bg-primary text-white" (click)="emit()">Chọn xong</button>
